<template>
    <div class="view" :style="{paddingTop:barh(0)}">
        <div class="content">
            <my-top title="审批" lefttext="" :arrow="false"></my-top>
            <h1 class="card-title">{{ processName }}</h1>
            <van-cell title-class="cell-title" title="节点信息" :value="taskName" />
            <van-cell title-class="cell-title" title="审批人" :value="userInfo && userInfo.name ? userInfo.name : ''" />
            <van-cell title-class="cell-title" title="审批时间" :value="currentTime" />

            <!-- 通用审批 start -->
            <baseForm ref="baseForm" :btnGroup="btns"></baseForm>
            <!-- 通用审批 end -->

            <!-- 审批流程信息start  -->
            <h1 class="card-title">审批流程信息</h1>
            <flowList :procInstId="procInstId"></flowList>
            <!-- 审批流程信息end  -->
        </div>
    </div>
</template>

<script>
    import { Dialog, Button, Toast, Form, List, Cell, Tag } from 'vant';
    import application from '@api/application';
    import baseForm from './baseForm.vue';
    import flowList from './flowList.vue';
    export default {
        name:'mattersDetail',
        components: {
          baseForm,
          flowList,
          Dialog,
          Button,
          Toast,
          Form,
          List,
          Cell,
          Tag
        },
        data() {
            return {
              rules: [{ required: false }],
              btnLoading: {
                scoreBtn: false,
                approval: false,
                unUpproval: false
              },
              btns: {
                ok: '确认签字',
                no: '驳回'
              },
              opinions: '',
              businessId: '', // 指定业务ID
              procInstId: '', //当前流程实例ID
              taskId: '', //当前流程节点ID
              processName: '', //流程名称
              taskName: '', //当前流程节点名称
              taskDefKey: '', //任务标识
              currentTime: '', //当前审批时间
              currentUser: '', //当前审批人
              flowRequesting: false,
              detailUrl: null, //详情地址

              assignType: '', //节点类型   0 变量获取 1 处理人 2 候选人 3 候选组 4 会签
              assignCode: '', //候选组编码 岗位编码
              assignLevel: '', //层级 项目部 PD 分公司 BC 公司 CO
              businessType: '' //业务类型 0 项目
            }
        },
        created(){
          const { type, code, level, btype, businessId, procInstId, name, processName, detailUrl, taskId, taskDefKey, opinions } = this.$route.query
          if (type) {
              this.assignType = type
              this.assignCode = code
              this.assignLevel = level
              this.businessType = btype
          }
          if (opinions) {
            this.opinions = opinions
          }
          this.businessId = businessId
          if (!this.businessId) {
              Toast('无指定业务ID，将自动关闭');
              setTimeout(() => {
                  this.toback()
              }, 1500)
              return
          }
          this.procInstId = procInstId
          this.taskName = decodeURIComponent(name)
          this.processName = decodeURIComponent(processName)
          if (detailUrl) {
              this.detailUrl = decodeURIComponent(detailUrl)
          }
          // else {
          //     this.detailUrl = '/process/auditBusinessDetail'
          // }
          this.taskId = taskId
          this.taskDefKey = taskDefKey
          this.currentTime = this.formatTime(new Date(), true)
          //获取流程节点执行情况
          // this.getProcessNodes()
        },
        computed: {
          active() {
            return this.$route.query.active
          },
          userInfo() {
            return localStorage.getItem("vuex") ? JSON.parse(localStorage.getItem("vuex")).user.userInfo : {}
          },
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .view {
        .content {
          .card-title {
            font-size: 1.6rem;
            font-weight: normal;
            padding: 1rem 1.6rem;
            color: #999;
            background: #f7f8fa;
          }
          .msg-textarea {
            ::v-deep .van-field__value {
                color: #969799;
                background: #f7f8fa;
            }
            background: none;
          }
          ::v-deep .cell-title {
            width: 8rem;
            flex: none;
          }
          .btns {
            overflow: hidden;
            padding: 1rem 1.6rem;
            ::v-deep .van-button {
              border-radius: 0.4rem;
              float: right;
              margin-left: 1rem;
            }
          }
          .item-box {
            display: flex;
            align-items: center;
            overflow: hidden;
            line-height: 2.4rem;
            font-size: 1.4rem;
            padding: 1rem 1.6rem;
            position: relative;
            &:active {
              background-color: #f2f3f5;
            }
            &::after {
              right: 0 !important;
              left: 0 !important;
              position: absolute;
              box-sizing: border-box;
              content: ' ';
              pointer-events: none;
              right: 1.6rem;
              bottom: 0;
              left: 1.6rem;
              border-bottom: 0.1rem solid #ebedf0;
              -webkit-transform: scaleY(.5);
              transform: scaleY(.5);
            }
            .item-left {
              width: 3rem;
              height: 3rem;
              line-height: 3rem;
              text-align: center;
              color: #fff;
              font-size: 1.6rem;
              border-radius: 100%;
              background: #169BD5;
              margin-right: 1rem;
            }
            .item-center {
              flex: 1;
              overflow: hidden;
              .item-title {
                display: flex;
                .title-name {
                  font-size: 1.6rem;
                  flex: 1;
                }
                .title-tag {
                  border-radius: 4px;
                  font-size: 1.2rem;
                  line-height: 2.4rem;
                  padding: 0 0.6rem;
                  margin-right: 1rem;
                  height: 2.4rem;
                }
                .title-tag-success {
                  color: #02A7F0;
                  border: 1px solid #02a7f0;
                  background: #02a7f019;
                }
                .title-tag-error {
                  color: #F5222D;
                  border: 1px solid #ffa39e;
                  background: #fef0ef;
                }
                .title-time {
                  max-width: 12rem;
                  text-align: right;
                  color: #999;
                }
              }
              .item-content {
                color: #999;
              }
              .item-subcontent {
                color: #999;
                font-size: 1.2rem;
              }
            }
            .item-right-icon {
              margin-left: 0.4rem;
              color: #969799;
            }
          }
            // padding-: 1rem;
        }
    }

</style>
